import React from 'react';
import Image from '@/src/shared/components/Image';
import { Button } from '@/src/shared/components/Button';
import styles from './BookADemoCard.module.scss';

type Props = {
  src: string;
  title: React.ReactNode;
  description: React.ReactNode;
  ctaLabel: React.ReactNode;
  onCtaClick: () => void;
};

export function BookADemoCard({
  src,
  title,
  description,
  ctaLabel,
  onCtaClick,
}: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.imageWrapper}>
          <Image src={src} fill alt="" />
        </div>
        <h2 className={styles.title}>{title}</h2>
        <hr className={styles.divider} />
        <p className={styles.description}>{description}</p>
        <Button
          className={styles.cta}
          onClick={() => onCtaClick()}
          color="primary"
          endIcon="arrow-right"
        >
          {ctaLabel}
        </Button>
      </div>
    </div>
  );
}
